import React, { useState } from 'react';
import { Button, Card, Typography } from 'antd';
import { CodeOutlined, LockOutlined } from '@ant-design/icons';
import { useFillHeight } from '../hooks/useViewportFit';

const { Text, Title } = Typography;

/**
 * 웹 터미널.
 *
 * 2026-09-02 보안 조치로 `/ttyd/` 는 Basic 인증 뒤로 들어갔다(그 전에는 인증 없이
 * root 셸이 열려 있었다). 화면을 열자마자 iframe 을 붙이면 브라우저가 401 을 받아
 * 인증 창을 띄우고 콘솔에 오류가 남는다 — 메뉴를 지나가기만 해도 그렇다.
 * 그래서 **누를 때 연결**한다. 접속을 의도한 순간에만 자격증명을 묻는다.
 */
const TerminalPage: React.FC = () => {
  /* 'calc(100vh - 상수)' 대신 실측 — 헤더/탭 높이가 달라져도 하단 여백이 정확히 유지된다 */
  const { ref, height } = useFillHeight(300);
  const [connected, setConnected] = useState(false);

  return (
    <div ref={ref} style={{ height }}>
      {connected ? (
        <div style={{ height: '100%', borderRadius: 12, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
          <iframe
            src="/ttyd/"
            style={{ width: '100%', height: '100%', border: 'none', background: '#000' }}
            title="Terminal"
          />
        </div>
      ) : (
        <Card
          style={{ height: '100%' }}
          styles={{
            body: {
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 14,
              textAlign: 'center',
            },
          }}
        >
          <CodeOutlined style={{ fontSize: 40, color: '#4f46e5' }} />
          <Title level={5} style={{ margin: 0 }}>서버 터미널</Title>
          <Text type="secondary" style={{ maxWidth: 460, fontSize: 13, lineHeight: 1.7 }}>
            이 터미널은 서버에서 직접 명령을 실행합니다. 메뉴 권한과 별개로
            <b> 접속 계정을 한 번 더 확인</b>하므로, 연결하면 브라우저가 아이디와 비밀번호를 묻습니다.
          </Text>
          <Button type="primary" size="large" icon={<LockOutlined />} onClick={() => setConnected(true)}>
            터미널 연결
          </Button>
        </Card>
      )}
    </div>
  );
};

export default TerminalPage;
